// extracted by mini-css-extract-plugin
export default {"wrapper":"C_FAQSet_wrapper__sdUIi"};